module.exports = __webpack_public_path__ + "img/sendnoti.c646f5cf.png";